<template>
    <ListPage :query="query" :total="total" v-loading="loading" :data="tableData" @size-change="handleSizeChange"
        @current-change="handleCurrentChange" @search="handleSearch" @reset="resetQuery">
        <template slot="filters">
            <el-form-item label="发布人" prop="userId">
                <el-input v-model="query.userId" placeholder="搜索用户手机号或ID" clearable
                    @keyup.enter.native="handleSearch" />
            </el-form-item>
            <el-form-item label="帖子标题" prop="title">
                <el-input v-model="query.title" placeholder="搜索帖子标题" clearable @keyup.enter.native="handleSearch" />
            </el-form-item>
            <el-form-item label="发布时间" prop="date">
                <el-date-picker v-model="query.date" value-format="yyyy-MM-dd" type="daterange" range-separator="~"
                    start-placeholder="开始日期" end-placeholder="结束日期">
                </el-date-picker>
            </el-form-item>
        </template>
        <template slot="columns">
            <el-table-column type="index" label="序号" width="100" align="center" />
            <el-table-column label="帖子ID" align="center" prop="id"></el-table-column>
            <el-table-column label="发布时间" align="center" prop="publishTime"></el-table-column>
            <el-table-column label="发布人" align="center" prop="userName"></el-table-column>
            <el-table-column label="推荐权重" align="center" prop="recommendWeight"></el-table-column>
            <el-table-column label="状态" align="center" prop="shelfStatus">
                <template slot-scope="{ row }">
                    {{ row.shelfStatus === 1 ? '正常' : '下架' }}
                </template>
            </el-table-column>
            <el-table-column label="操作" align="center" width="220"
                v-if="permission('/community/recommend/detail') || permission('/community/recommend/cancel') || permission('/community/recommend/weight')">
                <template slot-scope="{ row }">
                    <el-link v-if="permission('/community/recommend/detail')" :underline="false" type="primary"
                        @click="handleDetail(row)">
                        详情
                    </el-link>
                    <el-link v-if="permission('/community/recommend/cancel')" :underline="false" type="primary"
                        @click="handleCancel(row)">
                        取消推荐
                    </el-link>
                    <el-link v-if="permission('/community/recommend/weight')" :underline="false" type="danger"
                        @click="handleWeight(row)">
                        修改权重
                    </el-link>
                </template>
            </el-table-column>
        </template>
        <el-dialog title="修改权重" :visible.sync="visible" width="500px">
            <el-form :model="form" ref="form" :rules="rules" label-width="120px">
                <el-form-item label="排序权重" prop="weight">
                    <el-input v-model="form.weight" placeholder="请输入排序权重" />
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="visible = false">取 消</el-button>
                <el-button type="primary" @click="handleConfirm">确 定</el-button>
            </div>
        </el-dialog>
    </ListPage>
</template>

<script>
import { page, postTop } from "@/api/community/post";
import listMixin from '@/mixins/list';
export default {
    data() {
        return {
            // 查询参数
            query: {
                userId: "",
                title: "",
                date: [],
                recommendWeight: 1,
                auditStatus: 2,
                pageNo: 1,
                pageSize: 10
            },
            visible: false,
            form: {
                name: '',
                weight: '',
            },
            rules: {
                weight: [{ required: true, message: '请输入排序权重' }],
            },
        };
    },
    mixins: [listMixin],
    methods: {
        search() {
            const num = /^[\d]*$/;
            if (!num.test(this.query.userId)) {
                this.$message.error('用户手机号或ID格式不正确')
                return;
            }
            this.loading = true;
            const params = {
                ...this.query,
                startTime: this.query.date[0] ? this.query.date[0] + ' 00:00:00' : '',
                endTime: this.query.date[1] ? this.query.date[1] + ' 23:59:59' : '',
            };
            delete params.date;
            page(params).then(({ code, result, message }) => {
                if (code == 200) {
                    this.tableData = result.records;
                    this.total = result.total;
                } else {
                    this.$message.error(message);
                }
                this.loading = false;
            });
        },
        handleConfirm() {
            this.$refs.form.validate((valid) => {
                if (!valid) return;
                postTop({ id: this.form.id, recommendWeight: this.form.weight }).then(({ code, message }) => {
                    if (code == 200) {
                        this.$message.success('操作成功');
                        this.visible = false;
                        this.search();
                    } else {
                        this.$message.error(message);
                    }
                });
            });
        },
        handleDetail(row) {
            this.$router.push({ path: "/community/post/detail", query: { id: row.id } });
        },
        handleCancel(row) {
            this.$confirm('确定取消推荐该帖子吗？', '提示', {
                type: 'warning'
            }).then(() => {
                postTop({ id: row.id, recommendWeight: 0 }).then(({ code, message }) => {
                    if (code == 200) {
                        this.$message.success('操作成功');
                        this.search();
                    } else {
                        this.$message.error(message);
                    }
                });
            }).catch(() => { });
        },
        handleWeight(row) {
            this.visible = true;
            this.form = row;
        }
    },
};
</script>